import React, { useState } from "react";
import "./styles.scss";
import { Popconfirm } from "antd";
import Slider from "react-slick";
import { Button } from "..";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { deletePdf } from "../pdfUploader/service/pdf.service";
import { Store } from "react-notifications-component";

const Index = ({ data, onClickRemove, setPDFList }) => {
  let inputElement = null;

  const openWindow = (fileUrl) => {
    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      newWindow.document.write(`
      <html>
        <head>
          <title>New Window</title>
        </head>
        <body style="margin:0; padding:0; height:100vh;">
        <div>
          <div className={"cw__advertiesment-wrapper"}>
            <div className="top-ad active">

            </div>
            <div className="top-ad active">

            </div>
          </div>
          <iframe src="${fileUrl}" alt="PDF" width="100%" height="100%" />
        </div>
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  };

  const onClickRemovePDF = async (key) => {
    try {
      const res = await deletePdf(key);
      console.log("remove image", res);
      console.log(data.attachments);

      let updatedData = data?.attachments?.filter(
        (item) => item.file_name !== key
      );
      console.log("updatedData", updatedData);

      setPDFList(updatedData);
      Store.addNotification({
        title: "Success",
        message: "Image Delete successfully",
        type: "success",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
    } catch (error) {
      console.log("Error in deleting image", error);
      Store.addNotification({
        title: "Error",
        message: "Image Delete failed",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
    }
  };

  // slider
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = (data?.attachments?.length || 0) + 2; // +2 for "Home" and "Contact us"
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  const settings = {
    variableWidth: true,
    className: "slider variable-width",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: data?.attachments?.length,
    initialSlide: 0,
    customPaging: (i) => <div className="slick__dots--custom"></div>,
  };

  const onClickCancel = (e) => {
    console.log(e);
    // message.error("");
  };

  inputElement = (
    <>
      <div className={`pdf-preview-wrapper`}>
        <Slider
          {...settings}
          className={"rvow__slider d-flex flex-row justify-content-center"}
        >
          {data?.attachments?.map((file, index) => {
            return (
              <div className="slide-item">
                <div className="file-preview">
                  {<iframe src={file?.file_url} title="PDF" />}
                </div>
                <div className="file-actions">
                  <button onClick={() => openWindow(file?.file_url)}>
                    VIEW
                  </button>
                  <Popconfirm
                    placement="topLeft"
                    title="Delete the image"
                    description="Are you sure to delete this Image?"
                    onConfirm={() => onClickRemovePDF(file?.file_name)}
                    onCancel={onClickCancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div>DELETE</div>
                  </Popconfirm>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default Index;
